import styled from 'styled-components/macro'
import Typography from '@material-ui/core/Typography'

const Name = styled(Typography)`
  font-weight: bold;
`

export default Name
